// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X6bBe","colBig":"styles_colBig__1g5gF","colSmall":"styles_colSmall__1VMX4"};